module.exports = __webpack_public_path__ + "static/media/48364307_2308751312533380_6035712958338695168_o.01163d90.jpg";